export enum AuthorizationDomains {
  Any = 'Any',
  CashOffice = 'CashOffice',
  DataPattern = 'DataPattern',
  DeliveryAssurance = 'DeliveryAssurance',
  Device = 'Device',
  ElectronicJournal = 'ElectronicJournal',
  ManualStockCount = 'ManualStockCount',
  PersonalAccount = 'Personal Account',
  ReturnTransactionMode = 'ReturnTransactionMode',
  ReturnType = 'ReturnType',
  Role = 'Role',
  SalesFunctions = 'SalesFunctions',
  SalesTransactions = 'SalesTransactions',
  SelfCheckout = 'SelfCheckout',
  Services = 'Services',
  StockCount = 'StockCount',
  StoreHierarchy = 'StoreHierarchy',
  Store = 'Store',
  SupplierList = 'SupplierList',
  Tender = 'Tender',
  TouchpointGroups = 'TouchpointGroups',
  Touchpoint = 'Touchpoint',
  TrainingMode = 'TrainingMode',
  User = 'User',
}
